<sbnb-apps-detail-page
  vendorCode="linkbase"
  name="Linkbase"
  logoTile="/assets/images/apps/linkbase.png"
  builtBy="Linkbase"
  builtByLink="https://linkbase.ca"
  [categories]="['Guest verification', 'Guidebook']"
  [permissions]="[
    AppPermission.propertyRead,
    AppPermission.reservationRead,
    AppPermission.financialsRead,
    AppPermission.calendarRead,
    AppPermission.upsellShortcode,
    AppPermission.enrichmentGuidebookCode
  ]"
  email="shiven@linkbase.ca"
  phone="+1 250-859-7381"
  [helpLink]="{ href: 'https://calendly.com/shiven-7/30min', text: 'Schedule a call', icon: 'calendar' }"
  [helpArticles]="[
    {
      id: '10266267',
      title: 'Connect Hospitable with Linkbase for guest verification, guidebooks and upsells'
    }
  ]">
  <ng-container description>
    <div>
      <p>
        Say goodbye to the headaches of manual guest management and missed revenue opportunities! The Linkbase
        integration with Hospitable is here to revolutionize how you handle the guest journey—making it seamless,
        secure, and profitable.
      </p>

      <p><strong>What Does Linkbase Do for You?</strong></p>

      <p>
        <strong>Unlock New Revenue:</strong>
        With AI-driven upsells, you can effortlessly offer guests personalized services, local experiences, or upgrades,
        turning every stay into an opportunity for more income.
      </p>

      <p>
        <strong>Stress-Free Security:</strong>
        Automated guest verification ensures peace of mind, reducing risks and keeping your property secure.
      </p>

      <p>
        <strong>Hassle-Free Check-Ins:</strong>
        Integrate smart locks and lobby access, so guests check in and out effortlessly—no more coordinating keys or
        late-night calls.
      </p>

      <p>
        <strong>Simplify Deposits:</strong>
        Automate damage deposit collection and refunds with clear, transparent processes.
      </p>

      <p>
        <strong>Enhance Guest Experience:</strong>
        Provide digital guidebooks and step-by-step check-in instructions that wow your guests and make their stay
        smooth and memorable.
      </p>

      <p>
        <strong>Complete Control:</strong>
        Tailor every aspect of the guest journey with a rules-based system designed to fit your unique property needs.
      </p>

      <p><strong>Why Hosts Love Linkbase:</strong></p>

      <p>
        It’s all-in-one automation that saves you time, increases your revenue, and creates a seamless, five-star
        experience for your guests. With Linkbase, you can focus on what you do best—hosting—while the technology
        handles the rest.
      </p>

      <p>
        Make managing your properties easier, more profitable, and stress-free. Let Linkbase and Hospitable take care of
        the hard work so you can reap the rewards!
      </p>
    </div>
  </ng-container>

  <sbnb-image-carousel [images]="images"></sbnb-image-carousel>

  <div style="position: relative; padding-bottom: 56.25%; height: 0">
    <iframe
      src="https://drive.google.com/file/d/1JfULmRvVJeEw0m4SkL8nbgeaWZaD6Kv8/preview"
      frameborder="0"
      allowfullscreen
      style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"></iframe>
  </div>
</sbnb-apps-detail-page>
